'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/daily-report-review', {
      template: require('./dailyReportReview.pug'),
      controller: 'DailyReportReviewController',
      controllerAs: 'dailyReportReview',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/dailyReportReview/dailyReportReview.routes.ts